import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartBarHorz = () => {
  return (
    <g>
      <path d="m14.8389 8.9814h-1.6055v-2.663a.7.7 0 0 0 -.7-.7h-4.3654v-2.6624a.7.7 0 0 0 -.7-.7h-5.6067v-1.2746a.7.7 0 0 0 -1.4 0v14.0372a.7.7 0 1 0 1.4 0v-1.2745h12.9776a.7.7 0 0 0 .7-.7v-3.3625a.7.7 0 0 0 -.7-.7002zm-3.0059 0h-9.9707v-1.9629h9.9707zm-9.9707-5.3252h4.9053v1.962h-4.9053zm12.2764 8.6875h-12.2764v-1.9619h12.2764z" />
    </g>
  );
};

export default withIcon(IconChartBarHorz);
